import React from "react";
import { Modal, Form, Input, Row, Col } from "antd";
import { useTranslation } from "react-i18next";

const DeviceForm = ({ visible, onCancel, onConfirm, form, initialValues }) => {
  const { t } = useTranslation();
  return (
     
    <Modal
      title={`${t("device.edit")} `}  
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Submit"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        className="device-form"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="code"
              label={`${t("tableHeader.code")} `} 
              rules={[{ required: true, message: t("validation.deviceCodeRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="name"
              label={`${t("tableHeader.name")} `} 
              rules={[{ required: true, message:  t("validation.deviceNameRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="units"
              label={`${t("tableHeader.units")} `} 
              rules={[{ required: true, message:  t("validation.deviceUnitRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="device_group"
              label={`${t("tableHeader.deviceGroup")} `} 
              rules={[
                { required: true,  message: t("validation.deviceGroupRequired")},
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="device_type"
              label={`${t("device.deviceType")} `} 
              rules={[{  message: t("validation.deviceTypeRequired")}]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default DeviceForm;
